import { VIDEO_TEMPLATE_STATUS, VIDEO_TEMPLATE_TYPE } from '../constants.js';

const VIDEO_TEMPLATE_STATUS_LABELS = {
  [VIDEO_TEMPLATE_STATUS.AVAILABLE]: '可用',
  [VIDEO_TEMPLATE_STATUS.CREATED]: '已创建',
  [VIDEO_TEMPLATE_STATUS.UPLOADING]: '上传中',
  [VIDEO_TEMPLATE_STATUS.PROCESSING]: '导出中',
  [VIDEO_TEMPLATE_STATUS.UPLOAD_FAILED]: '上传失败',
  [VIDEO_TEMPLATE_STATUS.PROCESS_FAILED]: '导出失败',
};

const VIDEO_TEMPLATE_TYPE_LABELS = {
  [VIDEO_TEMPLATE_TYPE.TIMELINE]: '普通模板',
  [VIDEO_TEMPLATE_TYPE.VE_TEMPLATE]: '高级模板',
};

export function getVideoTemplateStatusLabel(status) {
  return status ? VIDEO_TEMPLATE_STATUS_LABELS[status] || status : '-';
}

export function getVideoTemplateTypeLabel(type) {
  return type ? VIDEO_TEMPLATE_TYPE_LABELS[type] || type : '-';
}
